import { render, staticRenderFns } from "./SalesOrderViewClientValidation.vue?vue&type=template&id=2fe17651"
import script from "./SalesOrderViewClientValidation.vue?vue&type=script&lang=js"
export * from "./SalesOrderViewClientValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports